import React from "react"
import Box from "@material-ui/core/Box"

/** Components */
import Drawer from "components/Drawer"
import Header from "components/Header"
import Summary from "./Summary"

interface DetailsProps {
  openState: boolean | undefined
  setopenState: Function
}

const VehicleDetails: React.FC<DetailsProps> = ({ openState, setopenState }) => {
  return (
    <Drawer openState={openState || false} setopenState={setopenState}>
      <Header
        title="Vehicle Details"
        subtitle="Unit Management / Vehicles"
        subtitleAbove
      />
      <Box height="100%">
        <Summary />
      </Box>
    </Drawer>
  )
}
export default VehicleDetails
